import React from 'react';

import {
  Box,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  BaseAccordion,
  PitchDeckTopicModal
} from 'modules';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';



const ContentText = styled(Typography)({
  color: '#1E3949',
  opacity: 0.54,
  fontSize: 14,
  fontWeight: 400
});

const ButtonGroupBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});

const SeeExamplesLinkBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  paddingRight: 1,
  paddingLeft: 4
});

const SeeExampleLinkText = styled(Typography)({
  color: '#87ACB9',
  fontSize: 12
});



interface IProps {
  title: string;
  content: string;
  seeExamplesLink?: string;
  isExpanded: boolean;
}

export const PitchDeckTopicAccordion: React.FC<IProps> = props => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => {
    setIsExpanded(props.isExpanded);
  }, [props.isExpanded]);



  return (
    <BaseAccordion.FC
      title={props.title}
      isExpanded={isExpanded}
      onExpand={isExpanded => setIsExpanded(isExpanded)}>
      <Stack spacing={2.5}>
        <ContentText>{props.content}</ContentText>

        <ButtonGroupBox>
          <PitchDeckTopicModal.FC title={props.title}/>

          <SeeExamplesLinkBox>
            {props.seeExamplesLink ? (
              <SeeExampleLinkText
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(props.seeExamplesLink as string, {
                  state: {
                    prevPath: location.pathname
                  }
                })}>
                See Examples
              </SeeExampleLinkText>
            ) : (
              <SeeExampleLinkText>See Examples</SeeExampleLinkText>
            )}
          </SeeExamplesLinkBox>
        </ButtonGroupBox>
      </Stack>
    </BaseAccordion.FC>
  );
};
